const formatOperationalTime = (data) => {
  if (data.start_operational_on.length == 0 || data.end_operational_on.length == 0) {
    return '-'
  }

  return `${data.start_operational_on} - ${data.end_operational_on}`
}

const formatBreakTime = (data) => {
  if (data.start_break_on.length == 0 || data.end_break_on.length == 0) {
    return '-'
  }

  return `${data.start_break_on} - ${data.end_break_on}`
}

const translate = (t, key, fallback) => {
  if (typeof t !== 'function') return fallback

  const translated = t(key)

  return translated === key ? fallback : translated
}

export const deliveryReadOnly = (t) => [
  { key: 'parent_number', label: translate(t, 'delivery.fields.deliveryNumber', 'No. Pengiriman'), value: '-', bold: true },
  { key: 'parent_customer.name', label: translate(t, 'delivery.fields.shippedCustomerName', 'Pelanggan Penerima'), value: '-', bold: true },
  { key: 'parent_company.name', label: translate(t, 'delivery.fields.billedCustomerName', 'Pelanggan Tertagih'), value: '-', bold: true },
]

export const originAddressReadOnly = (t) => [
  { key: 'city', label: translate(t, 'master.form.address.city', 'Kota'), value: '-', bold: true },
  { key: 'operationalTime', label: translate(t, 'master.form.customer.operationalTime', 'Waktu Operasional'), value: '-', bold: true, format: formatOperationalTime },
  { key: 'breakTime', label: translate(t, 'master.form.customer.breakTime', 'Waktu Istirahat'), value: '-', bold: true, format: formatBreakTime },
]

export const destinationAddressReadOnly = (t) => [
  { key: 'city', label: translate(t, 'master.form.address.city', 'Kota'), value: '-', bold: true },
  { key: 'operationalTime', label: translate(t, 'master.form.customer.operationalTime', 'Waktu Operasional'), value: '-', bold: true, format: formatOperationalTime },
  { key: 'breakTime', label: translate(t, 'master.form.customer.breakTime', 'Waktu Istirahat'), value: '-', bold: true, format: formatBreakTime },
]

export const boxCapacityReadOnly = (t) => [
  { key: 'boxCapacity', label: translate(t, 'deliveryRequest.fields.capacity', 'Kapasitas'), value: '-', bold: true },
]

export const fleetTaskReadOnly = (t) => [
  { key: 'parent_number', label: translate(t, 'delivery.fields.fleetTaskNumber', 'No. Penugasan'), value: '-', bold: true },
  { key: 'parent_company.name', label: translate(t, 'deliveryRequest.fields.senderName', 'Nama Pengirim'), value: '-', bold: true },
]
